import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

class SidePanel extends Component {
  static propTypes = {
    title: PropTypes.any,
    landingContent: PropTypes.any,
    step: PropTypes.number,
    formPage: PropTypes.string,
    mainTitle: PropTypes.any,
    highlightText: PropTypes.string,
    subtitle: PropTypes.any,
    subTitle: PropTypes.any,
    iconImg: PropTypes.string,
    illustration: PropTypes.string,
    badge: PropTypes.any,
  };

  render() {
    const {
      title,
      landingContent,
      step,
      formPage,
      mainTitle,
      highlightText,
      subtitle,
      subTitle,
      iconImg,
      illustration,
      badge,
    } = this.props;

    let defaultMainTitle = '';
    let defaultHighlight = '';
    let defaultSubtitle = '';

    const titleStr = typeof title === 'string' ? title : '';
    const isStep2 = step === 2 || titleStr.includes('2');
    const isStep3 = step === 3 || titleStr.includes('3');

    if (isStep2) {
      defaultMainTitle = 'Haz que tu espacio';
      defaultHighlight = 'destaque';
      defaultSubtitle = 'En este paso, deberás añadir algunas fotos y comodidades que ofrece tu espacio.';
    } else if (isStep3) {
      defaultMainTitle = 'Termina y';
      defaultHighlight = 'publica';
      defaultSubtitle = 'Elige las condiciones de reserva, el precio y el calendario de tu alojamiento.';
    }

    let displaySubtitle = defaultSubtitle;
    if (subtitle !== undefined && subtitle !== null) {
      displaySubtitle = subtitle;
    } else if (subTitle !== undefined && subTitle !== null) {
      displaySubtitle = subTitle;
    }
    const displayImg = iconImg || illustration;

    let headingContent;
    if (mainTitle) {
      headingContent = mainTitle;
    } else if (title && typeof title !== 'string') {
      headingContent = title;
    } else if (title && !title.includes('Paso') && !title.includes('Step')) {
      headingContent = (
        <>
          {title}
          {highlightText && (
            <>
              <span className={s.sidePanelHighlight}>{highlightText}</span>
            </>
          )}
        </>
      );
    } else {
      headingContent = (
        <>
          {defaultMainTitle}
          <span className={s.sidePanelHighlight}>{highlightText || defaultHighlight}</span>
        </>
      );
    }

    return (
      <div className={s.listBannerImageSection}>
        <div className={s.commonListStepSection}>
          {badge && (
            <div className={s.sidePanelBadge}>
              {badge}
            </div>
          )}
          <h1 className={s.sidePanelMainTitle}>
            {headingContent}
          </h1>
          {displaySubtitle && <p className={s.sidePanelSubtitle}>{displaySubtitle}</p>}
          <div className={s.sideIllustrationWrapper}>
            {/* Contenedor listo para agregar la ilustración manualmente */}
            {
              displayImg && <img src={displayImg} className={s.sideIlustrationImg} alt="" />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s, bt)(SidePanel);
